import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=6bff777c&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
import style0 from "./SearchFilterTokens.vue?vue&type=style&index=0&id=6bff777c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bff777c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6bff777c')) {
      api.createRecord('6bff777c', component.options)
    } else {
      api.reload('6bff777c', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=6bff777c&scoped=true&", function () {
      api.rerender('6bff777c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-8fiiSH5zIZxY7/JS/comp/SearchFilterTokens.vue"
export default component.exports